// removed by extract-text-webpack-plugin
module.exports = {"pie":"antd-pro-charts-pie-pie","chart":"antd-pro-charts-pie-chart","hasLegend":"antd-pro-charts-pie-hasLegend","legend":"antd-pro-charts-pie-legend","dot":"antd-pro-charts-pie-dot","line":"antd-pro-charts-pie-line","legendTitle":"antd-pro-charts-pie-legendTitle","percent":"antd-pro-charts-pie-percent","value":"antd-pro-charts-pie-value","title":"antd-pro-charts-pie-title","total":"antd-pro-charts-pie-total","legendBlock":"antd-pro-charts-pie-legendBlock"};


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/src/components/Charts/Pie/index.less
// module id = 621
// module chunks = 0